import BaseService, { getApplication, isDaf } from './BaseService.js';

// TODO need to bring auth
class AuthenticationService extends BaseService {
  getApplications() {
    return this.apiGet({
      url: '/applications',
      isDaf: true,
    });
  }

  login(username, password, firebaseToken, rest) {
    const headers = {
      CheckApplicationAccess: rest?.invited ? false : undefined,
    }
    if (firebaseToken) {
      headers.FbToken = firebaseToken;
      headers.Platform = 'web';
    }
    return this.apiPost({
      url: rest?.invited ? '/auth/app-invitation' : isDaf() ? '/auth/login' : '/login',
      data: rest?.invited ? {
        email: username,
        password,
        ...rest,
        invited: undefined,
      } : {
        email: username,
        password,
      },
      headers
    })
  }

  armToken() {
    return this.apiGet({
      url: '/arm-token',
    })
  }

  register(form) {
    return this.apiPost({
      url: isDaf() ? '/auth/sign-up' : '/sign-up',
      data: form,
    });
  }

  getRegistrationData(code) {
    return this.apiPost({
      url: isDaf() ? '/auth/registration-data' : '/registration-data',
      data: { code }
    });
  }

  getRegistrationOptions(data) {
    return this.apiPost({
      url: isDaf() ? '/auth/registration-options' : '/registration-options',
      data
    });
  }

  verify(code) {
    return this.apiPost({
      // url: isDaf() ? '/auth/verify' : '/verify',
      url: '/auth/verify',
      data: { code },
      isDaf: true,
    });
  }

  exitImpersonation() {
    return this.apiGet({
      url: '/profile/impersonate/exit',
    });
  }

  resetPasswordRequest(payload) {
    return this.apiPost({
      url: isDaf() ? '/forgot-password' : '/forgot-password',
      data: payload,
    });
  }

  changePassword(payload) {
    return this.apiPut({
      url: isDaf() ? '/profile/change-password' : '/profile/change-password',
      data: payload,
    });
  }

  resetPassword(payload) {
    return this.apiPut({
      url: isDaf() ? '/forgot-password/reset' : '/forgot-password/reset',
      data: payload,
    });
  }

  updateLanguage(language) {
    return this.apiPut({
      url: '/profile/language',
      data: {
        language
      },
    });
  }

  resendVerification() {
    return this.apiGet({
      url: isDaf() ? '/auth/rverification' : '/rverification',
    });
  }

  getInvitedUsers(id) {
    return this.apiGet({
      url: `/companies/${id}`,
    });
  }

  inviteUser(payload) {
    return this.apiPost({
      url: isDaf() ? '/auth/invite-user' : '/invite-user',
      data: payload,
    });
  }

  confirmInvitation({ password, mailUpdates }, token, code = {}) {
    return this.apiPost({
      url: isDaf() ? `/auth/invitation-confirm/${code.companyCode}/${code.userCode}` : `/invitation-confirm/${code.companyCode}/${code.userCode}`,
      data: {
        password: password || '',
        mailUpdates,
      },
      headers: token ? {
        Authorization: `Bearer ${token}`,
      } : undefined,
    });
  }

  getUserFromInvitation(code = {}) {
    return this.apiGet({
      url: isDaf() ? `/auth/invitation-confirm/${code.companyCode}/${code.userCode}` : `/invitation-confirm/${code.companyCode}/${code.userCode}`,
    });
  }

  demoLogin(token) {
    return this.apiGet({
      url: `/demo/${token}`,
    });
  }

  demoSignup(payload) {
    return this.apiPost({
      url: '/demo-signup',
      data: payload,
    });
  }

  resendEmail() {
    return this.apiGet({
      url: `/profile/resend-verification`,
    });
  }

  // User Settings
  editUserSettings(data = {}) {
    return this.apiPut({
      url: `/profile/${data.id}`,
      data,
    })
  }

  editSubUser(data = {}) {
    return this.apiPut({
      url: `/users/updateRole/${data.id}`,
      data,
    })
  }

  editUserAccess(userType, data = {}) {
    return this.apiPut({
      url: `/accounts/${userType.companyId}/user/${userType.id}/access`,
      data,
      isDaf: true,
    })
  }

  editRole(data = {}) {
    return this.apiPut({
      url: `/users/updateRole/${data.id}`,
      data,
    })
  }

  removeSubUser(companyId, userId) {
    return this.apiPut({
      url: `/companies/${companyId}/removeUser/${userId}`,
    })
  }

  resendSubUserInvite(id) {
    return this.apiPost({
      url: isDaf() ? `/auth/resendInvitation/${id}` : `/resendInvitation/${id}`,
    })
  }

  getFormOptions({ references = ['countries', 'categoriesOptions', 'subCategoriesOptions', 'locationCategory', 'eventsCategoryOptions'] }) {
    const app = getApplication();
    if (['mmt', 'admin'].includes(app)) {
      return this.apiPost({
        url: '/query/form-options',
        isDaf: true,
        data: {
          references,
        },
      })
    }

    return this.apiPost({
      url: `/${app}/formOptions`,
      isDaf: true,
      data: {
        references,
      },
    })
  }
}

export default new AuthenticationService();
